import { useaxios } from "../../../utils/useaxios";
export default (text) => recaller => setrecaller => items => setitems => settext => {
    var today = new Date();
    today = today.getFullYear() + '-' + (today.getMonth() + 1) + '-' + today.getDate();
    useaxios('item/getitem.php', { text }).then((res) => {
        if (res == "auth_failed") {
            alert('no internet connection');
            return false;
        }
        settext('');
        if (res.status == "ok") {
            if (items.find((lis) => lis.item_id == res.data[0].item_id)) {
                if (Number(items.find((lis) => lis.item_id == res.data[0].item_id).item_qty < Number(items.find((lis) => lis.item_id == res.data[0].item_id).item_quantity))) {
                    setitems(items.map((lis) => lis.item_id == res.data[0].item_id ?
                        {
                            item_id: lis.item_id,
                            service_id: 0,
                            item_name: lis.item_name,
                            item_barcode: lis.item_barcode,
                            item_price: lis.item_price,
                            item_sell_price: lis.item_sell_price,
                            item_qty: Number(lis.item_qty) + 1,
                            item_quantity: lis.item_quantity,
                            item_min_sell_price: lis.item_min_sell_price,
                            item_type: 'item'
                        } : lis));
                } else {
                    alert('یەکەی پێویست لەم خاڵایە لە مەخزەن نییە');
                }
            } else {
                if (Number(res.data[0].item_qty) > 0) {
                    setitems([
                        {
                            item_id: res.data[0].item_id,
                            service_id: 0,
                            item_name: res.data[0].item_name,
                            item_barcode: res.data[0].item_barcode,
                            item_price: res.data[0].item_price,
                            item_sell_price: res.data[0].item_price,
                            item_qty: 1,
                            item_quantity: res.data[0].item_qty,
                            item_min_sell_price: res.data[0].item_min_sell_price,
                            item_type: 'item'
                        }, ...items]);
                } else {
                    alert('یەکەی پێویست لەم خاڵایە لە مەخزەن نییە');
                }
            }
        } else {
            window.alert('هیچ کاڵایەک نەدۆزرایەوە');
        }
    });
}